import { createFileRoute } from '@tanstack/react-router'
import { MessageSquareText, Mails } from 'lucide-react'
import Banner from '@/components/banner'

export const Route = createFileRoute('/contact')({
  component: RouteComponent,
})

const contacts = [
  {
    title: 'Customer Service',
    icon: (
      <MessageSquareText
        className="text-icon-primary mb-4"
        size={80}
        strokeWidth={1}
      />
    ),
    content: (
      <>
        <a href="tel:1300 017 150">1300 017 150</a> (8am – 8pm AEST Mon-Fri)
        <a href="mailto:support@anex.com.au">support@anex.com.au</a>
      </>
    ),
  },
  {
    title: 'Technical Support',
    icon: (
      <Mails className="text-icon-primary mb-4" size={80} strokeWidth={1} />
    ),
    content: (
      <>
        <a href="tel:1300 017 150">1300 017 150</a> (24/7)
        <a href="mailto:support@anex.com.au">support@anex.com.au</a>
      </>
    ),
  },
]

function RouteComponent() {
  return (
    <>
      <Banner backgroundUrl="/img/banner.jpg" containerStyle="h-[320px]" />

      <div className="breakpoint-container px-0 md:px-4 -mt-[210px] z-10 mb-20">
        <h1 className="text-6xl text-white font-bold mb-15">Contacts</h1>
        <div className="card-row-container flex-wrap md:flex-nowrap">
          {contacts.map((data, index) => (
            <div className="card items-center w-full" key={index}>
              {data.icon}

              <h2 className="text-3xl font-bold mb-5 whitespace-pre-line">
                {data.title}
              </h2>

              {data.content}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
